import styled from 'styled-components'

export const Wrapper = styled.div`
  .formSection {
    /* border: 2px dotted blue; */
    height: 80vh;
    margin-top: 4.4rem;
  }
`;
